<template>
  <div id="exported">
    <div class="columns">
      <div :class="['column', exported && 'is-narrow']">
        <p class="title has-text-grey-light is-6">Exported</p>
      </div>
      <div :class="['column', !exported && 'is-narrow']">
        <div
          v-if="exported"
          class="title is-6 has-text-danger has-text-right has-text-left-mobile"
        >
          <p>
            <a
              v-tippy
              :title="tooltipContent"
              class="icon is-small has-text-info"
            >
              <i class="fal fa-info-circle" />
            </a>
            <span>
              The DVLA reported this vehicle was exported on
              {{ formatDate(data.dateExported) }}</span
            >
          </p>
          <p>It may have subsequently returned to the UK</p>
        </div>
        <p class="title is-6 has-text-success" v-else>Not exported</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date.utils.ts'
export default {
  name: 'AutoCheckExported',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    exported() {
      return this.data.exported
    },
    tooltipContent() {
      const date = this.formatDate(this.data.dateExported)
      return `The DVLA reported that this vehicle was exported on ${date}. This vehicle may have subsequently returned to the UK but Experian choose to report the export because details relating to this vehicle while the vehicle was exported will not be available for inclusion in this report.`
    }
  },
  methods: {
    formatDate
  }
}
</script>
